import axios from "axios";
import axiosClient from "axiosClient";
import { axiosHyperwolfDevClient } from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import { getQueryString } from "utilities/common";

export async function fetchDriversTerminalsAPI(data) {
    return await axiosHyperwolfDevClient.get('/api/v1/partner/store/inventory/terminals',
    )
  }